function replaceInnerHTMLWithRandomLine(elementID, filename) {
    fetch('/assets/txt/' + filename)
        .then(response => response.text())
        .then(data => {
            const quotes = data.split('\n').filter(quote => quote.trim().length > 0);
            const randomQuote = quotes[Math.floor(Math.random() * quotes.length)];
            document.getElementById(elementID).innerHTML = randomQuote;
        })
        .catch(error => console.error('Error fetching paths:', error));
}

// Give window permission to use the relevant functions.
Object.assign(window, {
    replaceInnerHTMLWithRandomLine
});